import {AbstractConditionDescriptionComponent} from "../AbstractConditionDescriptionComponent";

export class ConditionEquityExceeds extends AbstractConditionDescriptionComponent {
    static instance = () => AbstractConditionDescriptionComponent.instance(ConditionEquityExceeds, require('./ConditionEquityExceeds.html'))
}